export enum CartTypes {
    OrderCart = 1,
    AutoshipCart = 2,
    EnrollCart = 3,
    WishlistCart = 4,
    RecentlyViewed = 5
}
